import { render, staticRenderFns } from "./QccCompanyselfriskcount.vue?vue&type=template&id=6f8cafca&scoped=true&"
import script from "./QccCompanyselfriskcount.vue?vue&type=script&lang=js&"
export * from "./QccCompanyselfriskcount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8cafca",
  null
  
)

component.options.__file = "QccCompanyselfriskcount.vue"
export default component.exports